import Button from './Button'

Button.install = (Vue, options) => {
  Vue.component(Button.name, Button)
}
export default Button


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Button/index.js
// module id = null
// module chunks = 